import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar";
import Cookies from "js-cookie";
import Config from "../Config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { useAuthHandling } from '../useAuthhandling';
import Suspendmodal from "../Suspendmodal";
import { FaSearch } from 'react-icons/fa';
import Nodatafound from "../Nodatafound";

function Customer() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();
  const [search, setSearch] = useState('');

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }

  const [customerdata, setCustomer] = useState([]);
  const[paginate,setPaginate]=useState('');
  const [pagenum,setPagenum]=useState(1);
  const[pageindex,setPageindex]=useState(1);

  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");

  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }

  // const getinfo = async (e) => {
  //   const res = await fetch(
  //     `${Config.apiurl}/api/v1/crm/customer/get-customers?page=1`,
  //     {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${Cookies.get("a_token")}`,
  //       },
  //     }
  //   );
  //   if (res.status === 200 ) {
  //     const data = await res.json();

  //     setCustomer(data.data[0].data);
  //     setPaginate(data.data[0].total_pages);

  //   } 
  //   else if(res.status === 401){
  //     handleUnauthorized();
  //     getinfo();
  //   }
  //   else {
  //     alert("error");

  //   }
  // };

  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/user/search-normal-users?searchTerm=${search}&page=1`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200 ) {
      const data = await res.json();

      setCustomer(data.data[0].data);
      setPaginate(data.data[0].totalPages);

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  useEffect(() => {
    getinfo();
  }, [search]);

  const DeleteData = async (id) => {
    setmodal_animationFlip(false);

    // const response = await fetch(
    //   `${Config.apiurl}/api/v1/crm/customer/delete-customer/${id}`,
    //   {
    //     method: "PUT",
    //     headers: {
    //       Authorization: `Bearer ${Cookies.get("a_token")}`,
    //     },
    //   }
    // );


     const response = await fetch(
      `${Config.apiurl}/api/v1/crm/customer/suspend-customer/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );

    if (response.status === 200) {
      const deletedata = await response.json();

      toast.success("Customer Suspened", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handlePageClick(pagenum);
    } 
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData();
    }
    else {
    
    }
  };

  const fetchComments = async (currentPage) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/user/search-normal-users?searchTerm=${search}&page=${currentPage}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200) {

    const data = await res.json();
    return data.data[0].data;
    
  }
  else if(res.status === 401){
    handleUnauthorized();
    fetchComments(currentPage);
  }
  };

  const handlePageClick = async (data) => {
    if(data===1){
      setPageindex(1);

      setPagenum(data);
      const commentsFormServer = await fetchComments(data);
      setCustomer(commentsFormServer);
    }
    else{
    let currentPage = data.selected + 1;
    setPageindex(currentPage);

    setPagenum(data);
    const commentsFormServer = await fetchComments(currentPage);

    setCustomer(commentsFormServer);
    }
    
  };
  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                  <div className='user_list_search_all'>
                    <h4 className="card-title">Customer List</h4>
                    <div className='user_list_search'>
                                <input value={search} onChange={(e) => setSearch(e.target.value)} />
                                <FaSearch />
                            </div>
                  </div>
                    <div className="table-responsive pt-3">
                      {customerdata?.length>0?
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sl No</th>
                            <th>Name</th>
                            <th>E-mail</th>
                            <th>Contact Number</th>
                            <th>Location</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {customerdata.map((element, i) => {
                            return (
                              <>
                                <tr key={i}>
                                  <th scope="row">{pageindex===1 ? i + 1: (pageindex-1) * 10 + i + 1}</th>
                                  <td>{element.name}</td>
                                  <td>{element.email}</td>
                                  <td>{element.mobile}</td>
                                  <td>{element.location}</td>
                                  <td>
                                    <button
                                      // onClick={() =>
                                      //   deletecustomer(element._id)
                                      // }

                                      onClick={() => tog_animationFlip(element._id)}
                                    >
                                      <i className="fa-solid fa-trash" />
                                    </button>
                                    <button className="margin7">
                                      <Link
                                        to={`/editcustomer/${element._id}`}
                                        className="fa-solid fa-pen"
                                        style={{ color: "black" }}
                                      ></Link>
                                    </button>
                                    <ToastContainer />
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                      :
                      <Nodatafound/>
                        }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {paginate > 1 ? (
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={paginate}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              ) : (
                ""
              )}

          </div>
          {modal_animationFlip ? (
          <Suspendmodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"User"}
          />
        ) : (
          ""
        )}
        </div>
      </div>
    </div>
  );
}

export default Customer;
